import { render } from "./TenantRequest.vue?vue&type=template&id=ae0adf4a&scoped=true"
import script from "./TenantRequest.vue?vue&type=script&lang=js"
export * from "./TenantRequest.vue?vue&type=script&lang=js"

import "./TenantRequest.vue?vue&type=style&index=0&id=ae0adf4a&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae0adf4a"]])

export default __exports__